import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import App from "./App";
import { CurrentPlaylistProvider } from "./contexts/CurrentPlaylistContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { TermsProvider } from "./contexts/TermsContext";
import { PlayerProvider } from "./contexts/PlayerContext";
import { FavouritesProvider } from "./contexts/FavouritesContext";
import { AmbientSoundProvider } from "./contexts/AmbientSoundContext";
import reportWebVitals from "./reportWebVitals";
import "./styles.css";
import { Analytics } from "@vercel/analytics/react";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <TermsProvider>
      <ThemeProvider>
        <CurrentPlaylistProvider>
          <FavouritesProvider>
            <PlayerProvider>
              <AmbientSoundProvider>
                <App />
                <Analytics />
              </AmbientSoundProvider>
            </PlayerProvider>
          </FavouritesProvider>
        </CurrentPlaylistProvider>
      </ThemeProvider>
    </TermsProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
